import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-owner-cell-renderer',
    templateUrl: './owner-cell-renderer.component.html',
    styleUrls: ['./owner-cell-renderer.component.scss']
})
export class OwnerCellRendererComponent implements AgRendererComponent {

	params: ICellRendererParams;
	owners: string[] = [];
	isAbandoned: boolean;

	constructor() { }

	agInit(params: ICellRendererParams) {
	    this.params = params;
	    this.owners = this.params.data.Owners;
	    this.owners.sort((a, b) => {
	        const name1 = a.toLowerCase().trim();
	        const name2 = b.toLowerCase().trim();
	        if (name1 === name2) return 0;
	        return (name1 > name2) ? 1 : -1;
	    });
	    this.isAbandoned = this.params.context.contextUtil.isDashboardAbandoned(params.data.DashboardKey);
	}

	refresh(params: ICellRendererParams) {
	    this.params = params;
	    this.owners = this.params.data.Owners;
	    this.isAbandoned = this.params.context.contextUtil.isDashboardAbandoned(params.data.DashboardKey);
	    return true;
	}
}
